__turbopack_context__.v({
  "component": "style-module-scss-module__E40foq__component",
  "stats": "style-module-scss-module__E40foq__stats",
});
